<template>
  <div class="customer-service-faq px-3">
    <h3 class="ota-h2 text-center mb-3" v-text="$t('FAQ.Title')" />
    <p class="ota-p16 text-center mb-9" v-text="$t('FAQ.SubTitle')" />
    <div class="md:grid md:grid-cols-3 lg:grid-cols-4 md:gap-3 md:gap-y-1">
      <CustomerServiceFaqItem
        v-for="topic in topicsToLoop"
        :key="`${topic.url}-${topic.title}`"
        v-bind="topic"
        class="mb-3 md:col-span-1"
      />
    </div>
  </div>
</template>

<script>
import CustomerServiceFaqItem from '@/components/CustomerServiceFaq/CustomerServiceFaqItem'
import customerServiceMixin from '@/mixins/customerService'

export default {
  name: 'CustomerServiceFaq',
  components: {
    CustomerServiceFaqItem
  },
  mixins: [customerServiceMixin],
  props: {
    isWomen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    topicsToLoop () {
      if (this.isWomen) {
        return this.womenTopics
      }

      return this.topics
    }
  }
}
</script>

<style lang="postcss" scoped>
.customer-service-faq {
  @apply text-gray-600;

  .border-b {
    border-color: #DADADA;
  }

  .second-list {
    .border-b:last-child {
      @apply border-none;
    }
  }
}

@screen lg {
  .first-list {
    .border-b:last-child {
      @apply border-none;
    }
  }
}
</style>
